$ = require 'jquery'
View = require 'view'
entOrgPrefsVis = require 'views/templates/ent_org_prefs_vis'

module.exports = class OrganizationRestrictBoardVisibilityView extends View
  viewTitleKey: 'board creation restrictions'

  initialize: ->
    @listenTo @model, 'change:organizationPrefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    enterprise = @model.toJSON()

    @$el.html(entOrgPrefsVis(enterprise, @options.visibility))

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    prefName = "boardVisibilityRestrict/" + $target.closest('ul').attr('data-vis')
    setting = $target.closest('a').attr('data-restriction')

    isEnforcingSetting = @model.get('organizationPrefs').boardVisibilityRestrict?[@options.visibility]?

    if setting == 'undefined'
      if isEnforcingSetting
        @model.deleteOrganizationPref(prefName)
    else
      @model.setOrganizationPref(prefName, setting)



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/organization-restrict-board-visibility-view.coffee